// Kazakh-specific letters absent from the Russian alphabet.
const KAZAKH = /[әғқңөұүһіӘҒҚҢӨҰҮҺІ]/;
const CYRILLIC = /[а-яёА-ЯЁ]/;
const LATIN = /[a-zA-Z]/;

// Detect publication language from OCR text. Kazakh wins over Russian because
// any Kazakh-specific glyph is decisive; otherwise fall back to script family.
export function detectLanguage(text: string): string {
  if (KAZAKH.test(text)) return 'қазақша';
  if (CYRILLIC.test(text)) return 'русский';
  if (LATIN.test(text)) return 'английский';
  return '';
}
